import type { infer as zInfer } from "zod";
import { number, object } from "zod";

export const setBigcommerceExchangeOrderStatus = {
  name: "setBigcommerceExchangeOrderStatus" as const,
  input: object({ exchangeOrderStatus: number() }),
  output: object({ success: object({}).optional() }),
};

export type SetBigcommerceExchangeOrderStatusInput = zInfer<
  typeof setBigcommerceExchangeOrderStatus.input
>;
export type SetBigcommerceExchangeOrderStatusOutput = zInfer<
  typeof setBigcommerceExchangeOrderStatus.output
>;
